import styled, { css } from 'styled-components/macro'

import { IconClock } from '@loadsmart/icons'
import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'
import { getToken as getMirandaWCToken } from '@loadsmart/miranda-react/dist/tokens'

import { StrikeThroughPrice } from 'legacy/components/LoadOffer/StrikeThroughPrice'
import { screen } from 'legacy/styles/screen'

function resolvePadding({ isPriceRange }) {
  if (isPriceRange) {
    return `${getToken('space-m')} ${getToken('space-m')} ${getToken('space-s')} ${getToken(
      'space-m'
    )}`
  }
  return `0 ${getToken('space-m')}`
}

export const ActionsFooterInnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${getToken('color-neutral-light')};

  padding: 0px ${getToken('space-m')};

  ${screen.md} {
    justify-content: space-between;
    padding: ${resolvePadding};
    flex-direction: row;
  }
`

export const ActionsFooterItemGroupContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${getToken('space-m')};
  padding-bottom: ${getToken('space-m')};
  justify-content: space-around;

  & > :not(:last-child) {
    margin-right: 5px;
  }

  ${screen.md} {
    margin: 0px;
    padding-bottom: 0px;
  }
`

export const ActionsFooterPricing = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row-reverse;

  ${StrikeThroughPrice} {
    margin-right: 5px;

    ${screen.md} {
      margin-right: 0px;
      margin-left: 5px;
    }
  }

  ${screen.md} {
    flex-direction: row;
  }
`

const Button = styled.button`
  align-items: center;
  border-radius: 4px;
  box-shadow: none;
  display: inline-flex;
  font-size: 12px;
  font-weight: bold;
  height: 36px;
  justify-content: center;
  text-transform: uppercase;
  transition: opacity 100ms;

  :hover {
    opacity: 0.7;
  }
`

export const BookButton = styled(Button)`
  background-color: ${getToken('color-primary')};
  border: 1px solid ${getToken('color-primary')};
  color: ${getToken('color-neutral-white')};
  padding: 0 12px;

  ${screen.md} {
    padding: 0 32px;
  }

  :disabled {
    background-color: ${getToken('color-neutral')};
    border: 1px solid ${getToken('color-neutral')};
    color: ${getToken('color-neutral-white')};
    cursor: default;
  }
`

export const BidButton = styled(Button)`
  background-color: ${getToken('color-neutral-lighter')};
  border: 1px solid ${getToken('color-neutral-lighter')};
  color: ${getToken('color-neutral-darker')};
  max-width: 62px;
  padding: 0 12px;

  ${screen.md} {
    padding: 0 18px;
    max-width: unset;
  }

  ${({ activeBid }) =>
    activeBid &&
    css`
      background-color: ${getToken('color-neutral')};
      border: 1px solid ${getToken('color-neutral')};
      color: ${getToken('color-neutral-white')};
    `};

  :disabled {
    cursor: not-allowed;
    user-select: none;
    border: 1px solid ${getToken('color-neutral-darker')};
    color: ${getToken('color-neutral-darker')};
    opacity: ${getMirandaWCToken('opacity-40')};

    :hover {
      opacity: ${getMirandaWCToken('opacity-40')};
    }
  }
`

export const ContractInfoContainer = styled.div``

export const StyledIconClock = styled(IconClock)`
  display: none;
  margin-left: 2px;
  margin-right: -2px;

  width: 20px;
  height: 20px;

  ${screen.md} {
    display: inline-block;
  }
`

export const StyledSmallLeftIconClock = styled(IconClock)`
  display: none;
  margin-left: -${getToken('space-2xs')};
  margin-right: ${getToken('space-xs')};

  width: ${getToken('space-m')};
  height: ${getToken('space-m')};

  ${screen.md} {
    display: inline-block;
  }
`
